import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

async function download(kind, scope, params) {
  const query = scope === "all" ? { scope: "all" } : { scope: "filtered", ...params };
  const res = await api.get(`/admin/export/${kind}`, { params: query, responseType: "blob" });
  const stamp = new Date().toISOString().slice(0, 10);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `propera-${kind}-${scope}-${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default function ExportButtons({ kind, params = {} }) {
  const [busy, setBusy] = useState(null);
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v && v !== "all"));
  const hasFilter = Object.keys(clean).length > 0;
  async function run(scope) {
    setBusy(scope);
    try { await download(kind, scope, clean); toast.success("CSV downloaded"); }
    catch { toast.error("Could not export CSV"); }
    finally { setBusy(null); }
  }
  const cls = "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors disabled:opacity-60";
  return (
    <div className="flex items-center gap-1.5" data-testid={`export-${kind}`}>
      <button data-testid={`export-${kind}-filtered`} disabled={!!busy} onClick={() => run("filtered")} title={hasFilter ? "Export the list with your current filters" : "No filters applied — exports the full list"} className={`${cls} bg-propera text-white border-propera hover:bg-propera-hover`}>
        {busy === "filtered" ? <Loader2 size={12} className="animate-spin" /> : <Download size={12} />} Export filtered
      </button>
      <button data-testid={`export-${kind}-all`} disabled={!!busy} onClick={() => run("all")} className={`${cls} bg-white text-neutral-700 border-neutral-200 hover:border-neutral-300`}>
        {busy === "all" ? <Loader2 size={12} className="animate-spin" /> : <Download size={12} />} Export all
      </button>
    </div>
  );
}
